import { type CardCountsApiModel } from '@webapp/modules/spending-cards/data-access/api-models/CardCountsApiModel'

export const mapCardCountsApiModel = (
  cardCounts: CardCountsApiModel
): {
  active: number
  pendingActivation: number
  locked: number
  canceled: number
} => ({
  active: cardCounts.active,
  pendingActivation: cardCounts.pending_activation,
  locked: cardCounts.locked,
  canceled: cardCounts.canceled,
})
